<app-main-navigation></app-main-navigation>
<app-price-robot-submenu></app-price-robot-submenu>
<div class="container pb-1" [ngClass]="{faded: loading}" *ngIf="data != null; else spinner">
    <app-price-robot-filter-box (refresh)="loadData()" [filter]="filter"
                                [page]="'competitors'"></app-price-robot-filter-box>

    <table class="table table-striped align-middle mt-4 table-sm">
        <tr>
            <th>Konkurrent</th>
            <th class="text-end">Varer matchet</th>
            <th class="text-end">Varer afventer</th>
            <th class="text-end">Fejl i varer</th>
        </tr>
        <tbody>
        <tr *ngFor="let competitor of data">
            <td>
                <a [routerLink]="'/price-robot/competitor/' + competitor.id" [queryParams]="{mode:'pending'}">
                    {{competitor.name}}
                </a>

            </td>
            <td class="text-end">
                <a [routerLink]="'/price-robot/competitor/' + competitor.id" [queryParams]="{mode:'approved'}">
                    {{competitor.approved_urls_count.toLocaleString().replace(',', '.')}}
                </a>
            </td>
            <td class="text-end">
                <a [routerLink]="'/price-robot/competitor/' + competitor.id" [queryParams]="{mode:'pending'}">
                    {{competitor.pending_urls_count.toLocaleString().replace(',', '.')}}
                </a>
            </td>
            <td class="text-end">
                <a [routerLink]="'/price-robot/competitor/' + competitor.id" [queryParams]="{mode:'error'}">
                    {{competitor.error_urls_count.toLocaleString().replace(',', '.')}}
                </a>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
